import { useLocalObservable } from 'mobx-react-lite';

import { TariffPlanCodeEnum } from '@constants';

type CouponItemType = {
  id: number;
  newAmount: string;
  discount: number;
  tariffPlan: TariffPlanCodeEnum;
};

export type CouponType = CouponItemType[];

export interface ICouponCodeStore {
  coupon: CouponType | null;
  applyCoupon(coupon: CouponType): void;
  getCouponForTariffPlan(
    tariffPlan: TariffPlanCodeEnum,
  ): CouponItemType | undefined;
  isAppliedForTariffPlan(tariffPlan: TariffPlanCodeEnum): boolean;
  get isAppliedCode(): boolean;
}

export function useCouponCodeStore() {
  const store = useLocalObservable<ICouponCodeStore>(() => ({
    coupon: [],

    applyCoupon(value: CouponType) {
      this.coupon = value;
    },

    get isAppliedCode() {
      return this.coupon.length > 0;
    },

    getCouponForTariffPlan(tariffPlan: TariffPlanCodeEnum) {
      return this.coupon?.find((i) => i.tariffPlan === tariffPlan);
    },

    isAppliedForTariffPlan(tariffPlan: TariffPlanCodeEnum) {
      return !!this.getCouponForTariffPlan(tariffPlan);
    },
  }));

  return store;
}
